<template>
    <div>
        <ModuleTitleNav :next-module="nextModule" :previous-module="previousModule" class="title-one">
            {{ moduleTitle }}
        </ModuleTitleNav>
        <div class="section-line" />
        <div class="info-text">
            <p>
                Work-based learning is defined as sustained interactions with industry or community
                professionals in real workplace settings or simulated environments that foster in-depth,
                firsthand engagement with the tasks required in a given career field that are aligned
                to curriculum and instruction.
            </p>
            <p>
                The learning may be experienced at actual work locations, in a traditional school setting,
                use of comprehensive simulated work environments, robotics, virtual reality, or gaming.
                If simulations are used to replace in-business experiences, the simulation must teach
                occupational skills and replicate job-like conditions.
            </p>
            <p>
                Work-based learning experience may include:
                <ul>
                    <li>Job shadowing</li>
                    <li>Mentorships</li>
                    <li>Career related competitions</li>
                    <li>Informational interviews</li>
                    <li>Internships (paid or unpaid)</li>
                    <li>Practicum</li>
                    <li>Clinicals</li>
                    <li>Service learning</li>
                    <li>Use of simulators, robotics, virtual reality or gaming</li>
                    <li>School-based, student led enterprises</li>
                    <li>Volunteering</li>
                    <li>Workplace field trips/tours</li>
                </ul>
            </p>
        </div>
        <br>
        <fieldset :disabled="formDisabled">
            <b-row>
                <b-col>
                    <div class="info-text-section-marker">
                        [Sec 134 (b)(6)]
                    </div>
                    <div class="info-text">
                        Describe the work-based learning opportunities that the college will provide
                        to students participating in CTE programs and how it will work with
                        representatives from employers to develop or expand work-based learning
                        opportunities for CTE students, as applicable.
                    </div>
                    <b-form-textarea v-model="workBasedLearning" :rows="3" />
                </b-col>
            </b-row>
        </fieldset>
        <br>
        <b-row>
            <b-col>
                <LocalApplicationModuleActions
                    :is-loading="isSaving"
                    :is-disabled="formDisabled"
                    background-color="#006438"
                    @saveForm="saveForm"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { Log } from '$Shared/@arc/vue-arc';

const storeModuleName = 'workBasedLearning';
// const storeModuleNamespace = 'localApplications/module';

export default {
    name: 'WorkBasedLearning',

    props: {
        // formDisabled: { type: Boolean, default: true },
    },

    data() {
        return {
            isSaving: false,
            moduleTitle: 'Work-Based Learning',
            nextModule: { name: 'localApplication.EarlyCollegeCredit' },
            previousModule: { name: 'localApplication.SpecialPopulations' },
        };
    },

    computed: {
        ...mapState('localApplication', {
            currentState: (state) => state.localApplicationData.state.currentState
        }),

        ...mapGetters({
            isAuthorized: 'auth/isAuthorized',
            localApplicationModuleContent: `localApplication/module/${storeModuleName}/content`
        }),

        formDisabled() {
            return !this.isAuthorized('update', 'local_application', this.currentState);
        },

        workBasedLearning: {
            get() { return this.localApplicationModuleContent.workBasedLearning; },
            set(value) { this.updateContentField({ field: 'workBasedLearning', value }); }
        }
    },

    methods: {
        ...mapActions(`localApplication/module/${storeModuleName}`, {
            saveLocalApplicationModule: 'save',
            updateContentField: 'updateContentField'
        }),

        async saveForm() {
            this.isSaving = true;
            try {
                const response = await this.saveLocalApplicationModule();
                this.isSaving = false;
                Log.debug(response, `COMPONENT:${this.name} -> Save module response:`);
            } catch (error) {
                this.isSaving = false;
            }
        }
    }
};
</script>
